module.exports = __webpack_public_path__ + "static/media/lg-logo-circle.8aa02a8d.svg";